import { ISolServiceApiServiceMock } from "@/services";

export const mockSolServiceApi = (): ISolServiceApiServiceMock => ({
  getDeclaredValues: jest.fn(),
  saveDeclaredValue: jest.fn(),
  saveDeclaredValuePack: jest.fn(),
  updateDeclaredValue: jest.fn(),
  updateDeclaredValuePack: jest.fn(),
  deleteDeclaredValue: jest.fn(),
});
